// extracted by mini-css-extract-plugin
module.exports = {"container":"ArtistCard_container__35l2D","avatar":"ArtistCard_avatar__da0Ie","nameHover":"ArtistCard_nameHover__oPrDP","name":"ArtistCard_name__UuJy1"};